










import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_ordersSearch_orders } from '@/queries/__generated__/ordersSearch';
import uniq from 'lodash/uniq';

@Component
export default class InvoiceNewButton extends Vue {
  @Prop(Array) public orders!: GQL_ordersSearch_orders[];

  public navigate() {
    if (this.orders.length < 1) {
      this.$sPopup.alert(this.$t('PopupBody.nothingSelected'), { title: this.$t('PopupTitle.orderInvoiceProblems'), closeText: 'OK' });
      return;
    }

    const problems = [];

    if (this.orders.some(o => !o.isLocked)) problems.push('notLocked');
    if (this.orders.some(o => o.invoice)) problems.push('alreadyInvoiced');
    if (uniq(this.orders.map(o => o.export)).length > 1) problems.push('cannotMixExportAndDomesticOrders');
    if (uniq(this.orders.map(o => o.supplierParty.vatRegulation)).length > 1) problems.push('cannotUseOrdersWhereSupplierPartyVatRegulationDiffer');
    if (uniq(this.orders.map(o => o.customer.id)).length > 1) problems.push('multipleCustomers');
    if (uniq(this.orders.map(o => o.currencyCode)).length > 1) problems.push('multipleCurrencies');

    if (problems.length > 0) {
      let message = this.$t('PopupBody.orderInvoiceProblems');

      problems.forEach(problem => {
        message += '\n    • ';
        message += this.$t('PopupBody.' + problem) as string;
      });

      this.$sPopup.alert(message, { title: this.$t('PopupTitle.orderInvoiceProblems'), closeText: 'OK' });
    } else {
      const orderIds = this.orders.map(o => o.id);
      this.$router.push({ name: 'InvoicesNew', query: { orderIds } });
    }
  }
}
